module.exports = "https://www.gc-pro.gnp.com.mx/df2c01b20bfbca40757cafd804a9471c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/flecha-abajo-blanco.svg
// module id = 967
// module chunks = 0